"use client";
import CopilotLayoutContent from "@/app/[locale]/(user-page)/components/layout/CopilotLayoutContent";
import PopupAssistant from "@/components/Popup_Assistant";
import { StoreActionProvider } from "@/hooks/context/StoreActionContext";
import { ConfigData } from "@/models/config";
import { User } from "@/models/user";
import Footer from "@components/Footer";
import Header from "@components/Header";
import ThemeRegistry from "@components/Theme/ThemeRegistry";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";
import PopupOrganization from "../popup/PopupOrganization";

interface clientLayoutContentProps {
  children: React.ReactNode;
  lang: string | any;
  currency?: string;
}
const ClientLayoutContent = ({
  children,
  lang,
  currency,
}: clientLayoutContentProps) => {
  const queryClient = useQueryClient();
  const user = queryClient.getQueryData<User>(["user"]);
  const config = queryClient.getQueryData<ConfigData>(["config"]);
  const isProd = process.env.NODE_ENV === "production";
  const isStaging = process.env.NODE_ENV === ("staging" as any);

  return (
    <ThemeRegistry>
      <CopilotLayoutContent user={user} config={config} lang={lang}>
        <StoreActionProvider user={user} lang={lang}>
          <div className="flex-col flex heightScreen">
            <Header currency={currency} lang={lang} />
            <main className="flex-1">{children}</main>
            <Footer />
            {(isProd || isStaging) && (
              <PopupAssistant user={user} locale={lang} />
            )}
            {user && user?.isWarningOrganization && (
              <PopupOrganization user={user} />
            )}
          </div>
        </StoreActionProvider>
      </CopilotLayoutContent>
    </ThemeRegistry>
  );
};

export default ClientLayoutContent;
